import request from '../request'

/**
 * 获取图片数据列表。
 * @returns {Promise<{list: Array}>} 图片列表（含 id, name, url, size, type, uploadTime 等字段）
 */
export function fetchImageList() {
  return request({
    url: '/api/upload/list',
    method: 'GET',
  })
}

/**
 * 获取视频数据列表。
 * @returns {Promise<{list: Array}>} 视频列表（含 id, name, url, size, type, uploadTime 等字段）
 */
export function fetchVideoList() {
  return request({
    url: '/api/upload/video-list',
    method: 'GET',
  })
}

/**
 * 删除上传文件（图片或视频）。
 * @param {string} fileName 文件名。
 * @returns {Promise}
 */
export function deleteUploadFile(fileName) {
  return request({
    url: `/api/upload/${fileName}`,
    method: 'DELETE',
  })
}
